import { siteInfo } from '@/mocks/homepage';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-foreground-900 text-white/80">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-white text-lg"></i>
              </span>
              <span className="text-lg font-bold text-white">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              每日精选擦边视频与擦边图片福利合集，火辣但不露骨，满足你的猎奇与视觉刺激需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-3">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#ranking" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer">热度榜单</a></li>
              <li><a href="#updates" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer">最新快讯</a></li>
              <li><a href="#cards" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a></li>
              <li><a href="#faq" className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-3">内容分类</h4>
            <ul className="space-y-2">
              <li><a href="#" onClick={(e) => e.preventDefault()} className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer">擦边视频</a></li>
              <li><a href="#" onClick={(e) => e.preventDefault()} className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer">擦边图片</a></li>
              <li><a href="#" onClick={(e) => e.preventDefault()} className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer">街拍精选</a></li>
              <li><a href="#" onClick={(e) => e.preventDefault()} className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer">热舞专区</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-3">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 md:mt-10 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; {currentYear} {siteInfo.name} · 火辣但不露骨 · 每日精选擦边视频与擦边图片福利合集
          </p>
          <div className="flex items-center gap-4">
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-white/40 hover:text-white/60 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-white/40 hover:text-white/60 transition-colors cursor-pointer">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}